import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin } from "lucide-react";

const DIRECTORS = [
  {
    name: "Princy Aslam",
    initials: "PA",
    role: "Managing Director",
    desc: "Princy Aslam leads the execution and operational direction of House of IHM. As Managing Director, she is responsible for driving the company's vision, overseeing ventures, and ensuring strategic alignment across all initiatives.",
    accent: "#2997FF",
  },
  {
    name: "Shaila Parveen",
    initials: "SP",
    role: "Director",
    desc: "Shaila Parveen plays a key role in the governance and strategic direction of the organization. As a core authority within the company structure, she provides stability, oversight, and long-term vision across its initiatives. She is also associated with BHM Sunrise Pvt. Ltd., contributing to its foundational operations and leadership.",
    accent: "#1D1D1F",
  },
];

export default function Directors() {
  return (
    <div data-testid="page-directors" className="ihm-page-enter">
      {/* Hero */}
      <section>
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-16">
          <span className="ihm-chip">Leadership</span>
          <h1
            data-testid="directors-title"
            className="mt-8 font-heading font-bold text-5xl md:text-7xl lg:text-[80px] tracking-tighter leading-[1.02]"
          >
            Board of Directors.
          </h1>
          <p className="mt-8 max-w-2xl text-[18px] text-[#6E6E73] leading-relaxed">
            The people behind House of IHM EdTech — guiding strategy, governance,
            and the long-term vision of the company.
          </p>
        </div>
      </section>

      {/* Cards */}
      <section className="border-t border-[#E5E5EA]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {DIRECTORS.map((d, i) => (
              <article
                key={d.name}
                data-testid={`director-card-${i}`}
                className="ihm-card p-8 md:p-12 group flex flex-col"
              >
                <div className="flex items-center gap-5">
                  <Avatar className="h-20 w-20 rounded-2xl border border-[#E5E5EA]">
                    <AvatarFallback
                      className="rounded-2xl text-white font-heading font-bold text-2xl tracking-tight"
                      style={{ backgroundColor: d.accent }}
                    >
                      {d.initials}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#86868B]">
                      {d.role}
                    </span>
                    <h3
                      data-testid={`director-name-${i}`}
                      className="mt-2 font-heading font-bold text-3xl md:text-4xl tracking-tight"
                    >
                      {d.name}
                    </h3>
                  </div>
                </div>

                <p className="mt-8 text-[16px] leading-relaxed text-[#6E6E73] flex-1">
                  {d.desc}
                </p>

                <div className="mt-8 pt-6 border-t border-[#E5E5EA] flex items-center justify-between">
                  <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#86868B]">
                    Member · Board
                  </div>
                  <span className="inline-flex items-center gap-2 text-[12px] font-mono uppercase tracking-[0.22em] text-[#86868B] opacity-60">
                    Profile coming soon
                    <ArrowUpRight size={14} />
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section>
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24">
          <div className="ihm-dark-block p-10 md:p-16 lg:p-20 relative overflow-hidden">
            <div className="absolute -left-20 -bottom-20 h-72 w-72 rounded-full bg-[#2997FF]/20 blur-3xl pointer-events-none" />
            <div className="relative max-w-3xl">
              <h3 className="font-heading font-bold text-3xl md:text-5xl tracking-tighter leading-[1.05]">
                Partner with us to build the future.
              </h3>
              <p className="mt-6 text-[16px] text-white/70 max-w-xl">
                Reach out to us to discuss partnerships, advisory engagements,
                or strategic conversations.
              </p>
              <Link
                to="/contact"
                data-testid="directors-contact-cta"
                className="mt-10 inline-flex items-center gap-3 rounded-full bg-white px-6 py-3 text-[14px] font-medium text-[#1D1D1F] transition-all duration-500 hover:bg-[#2997FF] hover:text-white"
              >
                Contact us
                <ArrowUpRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
